import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-shimmer',
  templateUrl: './dashboard-shimmer.component.html',
  styleUrls: ['./dashboard-shimmer.component.scss']
})
export class DashboardShimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
